module.exports = __webpack_public_path__ + "static/media/gift.5f116a9c.svg";